import { render, staticRenderFns } from "./AlertComponent.vue?vue&type=template&id=15bd8573&scoped=true"
import script from "./AlertComponent.vue?vue&type=script&lang=js"
export * from "./AlertComponent.vue?vue&type=script&lang=js"
import style0 from "./AlertComponent.vue?vue&type=style&index=0&id=15bd8573&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bd8573",
  null
  
)

export default component.exports